import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { modules } from '../data/product';
export function Modules() {
  return <section className="bg-paper px-4 py-6 sm:py-8" data-id="element-102" data-mp="1r4sov7zfhav5">
      <div className="mx-auto max-w-5xl" data-id="element-103" data-mp="1vxc3875xwa10">
        <h2 className="text-center text-2xl text-navy sm:text-4xl" data-id="element-104" data-mp="1vydgmiafh8lw">
          WHAT&apos;S INCLUDED
        </h2>

        <ul className="mt-4 grid gap-2.5 md:grid-cols-2" data-id="element-105" data-mp="20vdjylfw7x9b">
          {modules.map(module => <li key={module.num} className="flex flex-col rounded-xl border border-navy/10 bg-white p-4 shadow-sm" data-id="element-106" data-mp="147pf354ue17p">
              <p className="flex items-center gap-1.5 font-mono text-[11px] font-bold uppercase tracking-wider text-auto" data-id="element-107" data-mp="1d6b51lcn8iii">
                <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="1i6goie8reypi" />
                Module {module.num}
              </p>
              <h3 className="mt-1 text-lg text-navy sm:text-xl" data-id="element-109" data-mp="2onu1muvpxn83">
                {module.title}
              </h3>
              <p className="mt-1.5 text-sm font-medium leading-snug text-ink/80" data-id="element-110" data-mp="1v2wxjdp5u36">
                {module.body}
              </p>
              <p className="mt-auto pt-2 font-display text-base uppercase tracking-wide text-cyan" data-id="element-111" data-mp="3tylxtkdmy3jf">
                {module.kicker}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}